<div id="main" [style.grid-template-rows]="gridRows()">
  @if (!hideHeader()) {
    <div id="header-bg" class="p-2">
      <div id="header-menu" class="w-full h-full bg-emphasis rounded-lg flex flex-row">
        <a id="logo" class="h-full w-fit max-w-50 p-2 ml-4 cursor-pointer" routerLink="/">
          <img src="images/logo.png" class="h-full object-contain invert" />
        </a>

        <div class="ml-auto p-3 w-fit h-full flex flex-row items-center">
          @if (api.user()) {
            <div class="flex flex-col desktop">
              <span
                >{{ 'mainmenu.hello' | translate: api.user() }}
                <span class="font-bold">{{ api.user().fullname }}</span></span
              >
              @if (api.user().technikEmail) {
                <span class="text-xs text-muted-color">{{ api.user().technikEmail }}</span>
              }
            </div>
            <div class="h-3/4 m-6 w-0.5 bg-neutral-900 desktop"></div>
          }

          <div id="menu" class="contents">
            @for (link of menuLinks; track $index) {
              <a
                pButton
                variant="text"
                [text]="true"
                [severity]="rla.isActive ? undefined : 'contrast'"
                [label]="link.label | translate"
                [routerLink]="link.route"
                routerLinkActive="active"
                #rla="routerLinkActive"
              >
              </a>
            }
          </div>
        </div>
      </div>
    </div>
  }

  <div id="main-content">
    <p-toast />
    <router-outlet />
  </div>

  @if (!hideFooter()) {
    <div id="footer-bg" class="p-2">
      <div class="w-full h-full bg-emphasis rounded-lg flex flex-row items-center">
        <div id="copyright" class="text-center ml-3 text-muted-color">
          {{ 'footer.copyright' | translate:{currentYear} }}
        </div>
        <div id="footer-menu" class="ml-auto p-3 w-fit h-full flex flex-row items-center">
          @for (link of footerLinks; track $index; let isLast = $last) {
            @if (link.external) {
              <a
                pButton
                variant="text"
                [text]="true"
                [severity]="'contrast'"
                [label]="link.label | translate"
                [href]="link.route"
                target="_blank"
                rel="noopener noreferrer"
              >
              </a>
            } @else {
              <a
                pButton
                variant="text"
                [text]="true"
                [severity]="rla.isActive ? undefined : 'contrast'"
                [label]="link.label | translate"
                [routerLink]="link.route"
                routerLinkActive="active"
                #rla="routerLinkActive"
              >
              </a>
            }
            @if (!isLast) {
              <div class="rounded-full bg-neutral-500 w-2 h-2 desktop"></div>
            }
          }
        </div>
      </div>
    </div>
  }
</div>
